const getLitiumBaseUrl = () => {
  if (process.env.USE_LITIUM_URL_REWRITE === 'true' && typeof window === 'object') {
    var hostname = window.location.hostname.replace(/\/$/, '').replace('www.', '');
    return decodeURI(`${window.location.protocol}//litium.${hostname}`);
  }
  return process.env.LITIUM_URL || 'http://litium.vinga.dev';
};

export const litiumBaseUrl = getLitiumBaseUrl();
